module.exports = __webpack_public_path__ + "static/media/driver-white.71a546fb.svg";